{
  "display_name": "Andre",
  "site_url": "https://dev.hearthfire.ai",
  "tenant_name": "Andre's household"
}
